/** Send a log line to Nexus Debug Console (via parent frames). */
export const nexusDebugLog = (source, message, meta, level = 'info') => {
    const payload = {
        type: 'nexus-debug-log',
        source,
        message,
        meta: meta || null,
        level,
        ts: Date.now()
    };

    try {
        if (typeof console !== 'undefined') {
            if (meta) {
                console.log(`[${source}] ${message}`, meta);
            } else {
                console.log(`[${source}] ${message}`);
            }
        }
    } catch (e) {
        // ignore
    }

    try {
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(payload, '*');
        }
    } catch (e) {
        // ignore
    }
};
